import React, { useEffect, useRef, useState } from "react"
import { Box } from "@mui/material"
import { getCompanies, getElements, getTicketPriorities } from "../../services/autocomplete.service"
import { PADDING_BASE } from "../../assets/Styles"
import { filterTickets } from "../../services/ticket.service"
import { DataTicket, TicketsFilterFormModel } from "../../models/ticket.model"
import TicketsFilter from "./Filters"
import {
  TICKET_COMPANY_ALL, TICKET_PRIORITY_ALL, TICKET_STATUS_ALL,
  TICKET_STATUS_CLOSE, TICKET_STATUS_OPEN
} from "../../assets/appConstants/constants"
import PageContainer from "../common/PageContainer"
import { Link, useNavigate } from "react-router-dom"
import { useProject } from "../../context/ProjectContext"
import Breadcrumbs from "../common/Breadcrumbs"
import { useTicketsFilterContext } from "../../context/TicketsFilterContext"
import PrimaryMenuBar from "../TicketActions/TicketListingActions/PrimaryMenuBar"
import SecondaryMenuBar from "../TicketActions/TicketListingActions/SecondaryMenuBar"
import { TableSchema, columnId, rowDataPreprocesor, handleDoubleClickRow } from "./scheme"
import DataTable from "../common/DataTable2"
import SelectionMenuBar from "../TicketActions/TicketListingActions/SelectionMenuBar"


interface TicketsListingProps {
  setBlockScreen: (p: boolean) => void
}

const TicketsListing: React.FC<TicketsListingProps> = ({
  setBlockScreen
}) => {

  const navigate = useNavigate()
  const { selectedProject, isProjectUndefined } = useProject()
  const { ticketsFilter, setTicketsFilter, defaultTicketsFilter, checkAppliedFilters } = useTicketsFilterContext()

  const [ticketsList, setTicketsList] = useState<DataTicket[]>([])
  const [rowsSelection, setRowsSelection] = useState<string[]>([])
  const [dataTableResetSelection, setDataTableResetSelection] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const [ticketStatusList, setTicketStatusList] = useState<any[]>([])
  const [ticketPrioritiesList, setTicketPrioritiesList] = useState<any[]>([])
  const [elementsList, setElementsList] = useState<any[]>([])
  const [companiesList, setCompanyList] = useState<any[]>([])

  const setDefaultFilterLists = () => {
    setTicketStatusList([TICKET_STATUS_ALL])
    setTicketPrioritiesList([TICKET_PRIORITY_ALL])
    setElementsList([])
    setCompanyList([TICKET_COMPANY_ALL])
  }

  const handleOpenFilter = () => setOpenFilter(true)
  const handleCloseFilter = () => setOpenFilter(false)
  const [openFilter, setOpenFilter] = useState(false)
  const [resetSecondaryFilter, setResetSecondaryFilter] = useState<boolean>(false)
  const refreshPage = useRef<boolean>(true);

  useEffect(() => {
    setBlockScreen(true)
    setTimeout(() => { setBlockScreen(false) }, 1000)
  }, [])

  const initFilter = () => {
    resetFilter()
    setDefaultFilterLists()
    if (isProjectUndefined()) return
    Promise.all([
      getTicketPriorities(selectedProject),
      getElements(selectedProject),
      getCompanies(selectedProject),
    ]).then(function (result: any[]) {
      setTicketPrioritiesList((ticketPrioritiesList) => [...ticketPrioritiesList, ...result[0]]);
      setElementsList((elementsList) => [...elementsList, ...result[1]]);
      setCompanyList((companiesList) => [...companiesList, ...result[2]]);
      setTicketStatusList((ticketStatusList) => [...ticketStatusList, ...[TICKET_STATUS_OPEN, TICKET_STATUS_CLOSE]]);
    }).catch((error) => {
    });
  };

  useEffect(initFilter, [selectedProject])

  const setFilter = (filter: TicketsFilterFormModel) => {
    setOpenFilter(false)
    setLoading(true)
    setTicketsFilter(filter)
    checkAppliedFilters(filter)
    setResetSecondaryFilter(!resetSecondaryFilter)
    Promise.all([filterTickets(selectedProject, filter)]).then(function (results) {
      setTicketsList(results[0])
      setLoading(false)
    }).catch((error) => {
      setLoading(false)
    });
  }

  const resetFilter = () => {
    let currentFilter: TicketsFilterFormModel | undefined = refreshPage.current ? ticketsFilter : defaultTicketsFilter
    if (currentFilter) setFilter(currentFilter)
    refreshPage.current = false
  }

  const handleDoubleClickTicket = (rowData: DataTicket) => {
    handleDoubleClickRow(rowData, navigate)
  }

  return (
    <React.Fragment>

      <TicketsFilter
        openFilter={openFilter}
        currentFilter={ticketsFilter ? ticketsFilter : defaultTicketsFilter}
        defaultFilterForm={defaultTicketsFilter}
        setFilter={setFilter}
        resetFilter={resetFilter}
        handleCloseFilter={handleCloseFilter}
        ticketStatusOptions={ticketStatusList}
        ticketPrioritiesOptions={ticketPrioritiesList}
        companiesOptions={companiesList}
        elementsOptions={elementsList}
      />

      <PageContainer>

        <Box paddingBottom={PADDING_BASE}>
          <Breadcrumbs
            pathlist={[
              <Link className="breadcrumbs-nav__link" to="/tickets/listing">Home</Link>, 'Tickets'
            ]} />
        </Box>

        <div className="tickets-listing-section">
          <PrimaryMenuBar
            handleOpenFilter={handleOpenFilter}
            setSearch={setFilter}
            resetPrimaryFilter={resetFilter}
            defaultSearchForm={defaultTicketsFilter}
          />

          <div className="tickets-listing-section__secbar">

            {rowsSelection.length == 0 && (

              <SecondaryMenuBar
                setTicketsList={setTicketsList}
                setLoadingTickets={setLoading}
                resetPrimaryFilter={resetFilter}
                resetSecondaryFilter={resetSecondaryFilter}
              />
            )}

            {rowsSelection.length > 0 && (
              <SelectionMenuBar
                selection={rowsSelection}
                onClose={() => { setDataTableResetSelection(!dataTableResetSelection); resetFilter() }}
                setBlockScreen={setBlockScreen}
                resetFilter={resetFilter}
              />
            )}
          </div>

          <DataTable
            columns={TableSchema}
            rows={ticketsList.map(rowDataPreprocesor)}
            onRowDoubleClick={handleDoubleClickTicket}
            loading={loading}
            columnId={columnId}
            selectable={!isProjectUndefined()}
            handleRowSelection={(s: string[]) => setRowsSelection(s)}
            resetRowsSelection={dataTableResetSelection}
          />

        </div>

      </PageContainer>
    </React.Fragment>
  );
}

export default TicketsListing;